export class ErrorMessageConstants {
  static ERROR_LOGIN = 'Could not login';
  static ERROR_FETCHING_ENTERTAINMENT_PACKS = 'Error fetching the TvShopEntertainmentPacks';
  static ERROR_FETCHING_STREAMING_SERVICES = 'Error fetching the StreamingServices';
  static ERROR_LOGIN_OR_FETCHING_PACKS = ErrorMessageConstants.ERROR_LOGIN + ' or ' + ErrorMessageConstants.ERROR_FETCHING_ENTERTAINMENT_PACKS;
  static STREAMING_BUNDLE_ACTIVATION_ERROR = 'Streaming bundle activation error';
  static OCAPI_ERR_ODSO123 = 'OCAPI-ERR-ODSO123';
  static OCAPI_ERR_00089 = 'OCAPI_ERR_00089';
  static OCAPI_ERR_00090 = 'OCAPI_ERR_00090';
  static OCAPI_ERR_00091 = 'OCAPI_ERR_00091';
  static OCAPI_ERR_00092 = 'OCAPI_ERR_00092';
  static OCAPI_ERR_00093 = 'OCAPI_ERR_00093';
  static OCAPI_ERR_00094 = 'OCAPI_ERR_00094';
  static STREAMING_BUNDLE_WAITING_ACTIVATION = 'eos-tv-shop-ii.error.streaming-bundle-waiting-activation';
  static VOUCHER_NOT_VALID = 'eos-tv-shop-ii.error.voucher-is-not-valid';
  static VOUCHER_ALREADY_USED = 'eos-tv-shop-ii.error.voucher-already-used';
  static VOUCHER_GENERIC_ERROR = 'eos-tv-shop-ii.error.voucher-generic-error';
  static MAX_ATTEMPTS_REACHED = 'eos-tv-shop-ii.error.max-attempts-reached';
  static TRIAL_ALREADY_RUNNING = 'eos-tv-shop-ii.error.trial-already-running';


  static OCAPI_ERROR_MAP = new Map([
      [ErrorMessageConstants.OCAPI_ERR_00089, ErrorMessageConstants.VOUCHER_NOT_VALID],
      [ErrorMessageConstants.OCAPI_ERR_00090, ErrorMessageConstants.VOUCHER_NOT_VALID],
      [ErrorMessageConstants.OCAPI_ERR_00091, ErrorMessageConstants.VOUCHER_NOT_VALID],
      [ErrorMessageConstants.OCAPI_ERR_00092, ErrorMessageConstants.MAX_ATTEMPTS_REACHED],
      [ErrorMessageConstants.OCAPI_ERR_00093, ErrorMessageConstants.VOUCHER_ALREADY_USED],
      [ErrorMessageConstants.OCAPI_ERR_00094, ErrorMessageConstants.VOUCHER_GENERIC_ERROR]
    ]
  );

}
